import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export const HiddenFormValueCatcher = () => {
  const { control } = useFormContext();
  return (
    <div style={{ display: 'none' }}>
      <ValueCatcher name="requestedShift" control={control} />
      <ValueCatcher name="placementShift" control={control} />
      <ValueCatcher name="bestTimeToCall" control={control} />
      <ValueCatcher name="travelPartner" control={control} />
      <ValueCatcher name="placementDate" control={control} />
      <ValueCatcher name="placementStartDate" control={control} />
      <ValueCatcher name="placementEndDate" control={control} />
      <ValueCatcher name="availabilityDate" control={control} />
      <ValueCatcher name="sellingPoints" control={control} />
      <ValueCatcher name="requestedTimeOff" control={control} />
      <ValueCatcher name="ssn" control={control} />
      <ValueCatcher name="dob" control={control} />
      <ValueCatcher name="vmsReqNo" control={control} />
      <ValueCatcher name="contractHours" control={control} />
      <ValueCatcher name="numberOfWeeks" control={control} />
    </div>
  );
};

const ValueCatcher = ({ control, name }) => (
  <Controller name={name} control={control} render={({ field: { onChange, ...rest } }) => <input {...rest} />} />
);
